export const E1_dashboard_branchs = [
  {
    iconPath: "/static/icons/trend-icon.png",
    heading: "E1 Trend",
    url_extension_dashboard: "Efficience",
  },
  {
    iconPath: "/static/icons/absence-icon.png",
    heading: "Absence Trend",
    url_extension_dashboard: "Absents",
  },
  {
    iconPath: "/static/icons/activity-icon.png",
    heading: "The activity of responsible",
    url_extension_dashboard: "HoursOfProduction",
  },
  {
    iconPath: "/static/icons/effective-icon.png",
    heading: "N.Workers/Responsible",
    url_extension_dashboard: "Headcount",
  },
];

export const OEE_dashboard_branchs = [
  {
    iconPath: "/static/icons/trend-icon.png",
    heading: "OEE Trend",
    url_extension_dashboard: "oee",
  },
  {
    iconPath: "/static/icons/trend-icon.png",
    heading: "OEE Vs Setup time Trend",
    url_extension_dashboard: "oee",
  },
  {
    iconPath: "/static/icons/trend-icon.png",
    heading: "Scrap Trend",
    url_extension_dashboard: "oee",
  },
  {
    iconPath: "/static/icons/trend-icon.png",
    heading: "OEE Vs Scrap Trend",
    url_extension_dashboard: "oee",
  },
];

export const SCRAP_dashboard_branchs = [
  {
    iconPath: "/static/icons/waste-icon.png",
    heading: "Scrap Trend",
    url_extension_dashboard: "scrap",
  },
];
